import { useState, useCallback } from 'react';
import { useBeforeUnload, useBlocker, useNavigate } from 'react-router-dom';

export const FormPrompt = ({ hasUnsavedChanges, keyword, children }) => {
  const [showModal, setShowModal] = useState(false);
  const [savedNextLocation, setSavedNextLocation] = useState('');
  const [fromHandleClick, setFromHandleClick] = useState(false);
  const navigate = useNavigate();

  const toggleModal = () => {
    setShowModal(!showModal);
  };

  const onLocationChange = useCallback(
    ({ nextLocation }) => {
      // Normalize keyword to always be an array
      const keywords = Array.isArray(keyword) ? keyword : [keyword];

      if (
        !keywords.some((k) => nextLocation.pathname.includes(k)) &&
        hasUnsavedChanges &&
        !fromHandleClick
      ) {
        setShowModal(true);
        setSavedNextLocation(nextLocation.pathname);
        return true;
      }
      return false;
    },
    [hasUnsavedChanges, fromHandleClick, keyword]
  );

  useBlocker(hasUnsavedChanges ? onLocationChange : false);

  const handleClick = () => {
    setFromHandleClick(true);
    setTimeout(() => {
      navigate(savedNextLocation);
    }, 0);
  };

  // https://developer.mozilla.org/en-US/docs/Web/API/Window/beforeunload_event
  // Since Firefox 44, Chrome 51, Opera 38, and Safari 9.1,
  // a generic string NOT UNDER THE CONTROL OF THE WEBPAGE is shown instead of the returned string.
  useBeforeUnload(
    useCallback(
      (event) => {
        if (hasUnsavedChanges) {
          event.preventDefault();
          event.returnValue = '';
        }
      },
      [hasUnsavedChanges]
    ),
    { capture: true }
  );

  return children({ handleClick, toggleModal, showModal, savedNextLocation });
};
